module.exports = __webpack_public_path__ + "img/meal.311d5a7a.svg";